<template>
  <div class="h-dialogContainer">
    <form id="noRealTaskResourceReportDialog1">
      <div class="row">
        <div class="col-sm-6">
          <div class="h-col-inputBox-right">
            <div class="h-inputLit">{{$t('Pm.measureObj')}}</div>
            <ejs-listview
                    :dataSource='measureObjDataSourceOfResourceReport'
                    :showIcon='true'
                    :fields="measureObjFiledsOfResourceReport"
                    :select="measureObjSelectedOfReourceReport"></ejs-listview>
          </div>
        </div>
        <div class="col-sm-6">
          <div class="h-inputLit">{{$t('Pm.counterList')}}</div>
          <div class="h-borderBox height-250">
            <NoRealTaskMeasureTreeForResourceReport ref="NoRealTaskMeasureTreeForResourceReport"></NoRealTaskMeasureTreeForResourceReport>
          </div>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
  import CommonUtil from "../../../../util/CommonUtil";
  import NoRealTaskMeasureTreeForResourceReport from "../tree/NoRealTaskMeasureTreeForResourceReport";

  export default {
    name: 'NoRealTaskResourceReportDialog2',
    props: [
      'selectNeId',
      'selectNeType'
    ],
    components: {
      NoRealTaskMeasureTreeForResourceReport
    },
    data() {
      return {
        measureObjDataSourceOfResourceReport: [],
        measureObjFiledsOfResourceReport: {
          text: 'measureObjNameCH',
          value: 'measureObjCode',
        },
        measureObjCodeOfResourceReport: 1,
      }
    },
    methods: {
      measureObjSelectedOfReourceReport(args) {
        this.measureObjCodeOfResourceReport = args.data.measureObjCode;
        this.$refs.NoRealTaskMeasureTreeForResourceReport.getMeasureTreeForResourceReport(this.selectNeType,args.data.measureObjCode);
      },

      getMeasureListForResourceReport(neTypeCode){
        const params = {
          neTypeCode
        }
        this.$axios.get(`/lte/ems/pm/noReal/query/buildNoRealTaskMeasureObjListForQuery.html${CommonUtil.analyticParameter(params)}`).then((response) => {
          this.measureObjDataSourceOfResourceReport =response.data;
        });
      },
    },
    mounted() {
    }
  }
</script>

<style scoped>
  .h-dialogContainer .h-col-inputBox-left {
    margin-bottom: 18px;
    padding-left: 35px;
    padding-right: 10px;
  }

  .h-dialogContainer .h-col-inputBox-middle {
    margin-top: 25px;
    margin-bottom: 5px;
  }

  .h-dialogContainer .h-col-inputBox-right {
    margin-bottom: 18px;
    padding-left: 10px;
    padding-right: 35px;
  }

  .h-dialogContainer >>> .e-listview .e-list-item.e-active{
    background-color: #007bff;
    color: #fff;
  }
</style>
